// Dev-only logging. In production builds these are no-ops so the console stays
// clean and we don't pay the cost of serialising large diagram payloads.
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

const logger = {
  log: isDev ? console.log.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
  debug: isDev ? console.debug.bind(console) : noop,
  // Warnings and errors are kept in production - they surface real problems.
  warn: console.warn.bind(console),
  error: console.error.bind(console)
};

export default logger;
